<template>
<div class="wrap-container record-con" v>
  <div class="header Mini-Header-Model" v-if="!isApp">
    <a href="javascript:void (0)" class="back" @click="backToExam"></a>
    <h1>做题记录</h1>
  </div>
  <div class="re-main">
    <div v-swiper:kmSwiper="kmSwiperOpt" class="subTit">
      <ul class="swiper-wrapper">
        <li
          v-for="(item,index) in majorType"
          :key="index"
          class="swiper-slide"
          :class="{'on':item.isChoose===1}"
          @click="getRecordsApi(item.categoryID,index)">
          {{ item.categoryName }}
        </li>
      </ul>
    </div>
    <div class="conBox clearfix">
      <div class="listBox clearfix" v-if="recordsData && recordsData.length>0">
        <div class="roomBox" v-for="(item,index) in recordsData" :key="index">
          <div class="roomBox-tit on">
            <div class="rtJian-l"></div>
            <div class="rtTxt">{{ item.showName }}</div>
          </div>
          <div class="roomBox-con clearfix">
            <template v-if="item.paperViews && item.paperViews.length>0">
              <div class="unit" v-for="(part,idx1) in item.paperViews" :key="idx1" >
                <div class="uTit">
                  <div class="uTit-ltxt fl">{{ part.paperViewName }}</div>
                </div>
                <div class="uList" v-for="(obj,idx2) in part.records" :key="idx2">
                  <div class="uList-num fl">{{ obj.lastScore }}分</div>
                  <div class="uList-time fl">{{ obj.createTime }}</div>
                  <a :href="obj.analysisUrl" class="uList-btn fr">查看</a>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="nullBox" v-if="noData">
        <div class="nullBox-pic"><img src="//m.med66.com/qz/resources/images/qz/moniExam/null_01.png"></div>
        <div class="nullBox-txt">您还没做题记录<br>先去做题再来查看记录吧</div>
        <a href="javascript:void (0)" class="nullBox-btn" @click="backToExam">去答题</a>
      </div>
    </div>

  </div>
  <div class="loading" v-if="loading">
    <van-loading type="spinner" color="#999" />
  </div>
</div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { getCategoryMajors,getRecords } from '@/api'
import { getCookie } from "@/utils";
export default {
  name: "index",
  directives: {
    swiper: directive
  },
  data(){
    return{
      kmSwiperOpt: {
        slidesPerView: 'auto',
        freeMode: true,
        observer: true,
        observeParents: true
      },
      majorType:[],
      recordsData:[],
      isApp:false,
      loading:false,
      noData:false
    }
  },
  mounted() {
    const { index,urlName } = this.$route.query
    this.getCategoryMajorsApi(index,urlName)
    this.getRecordsApi(1)
    $(function (){
      //点击考场展开收起
      $("body").on("click", ".listBox .roomBox-tit", function () {
        var _this = $(this);
        if (_this.hasClass("on")) {
          _this.removeClass("on");
          _this.parents(".roomBox").find(".roomBox-con").slideUp();
        } else {
          _this.addClass("on");
          _this.parents(".roomBox").find(".roomBox-con").slideDown();
        }
      });
    })
    this.isApp = window.CDEL.isApp || !!window.CDEL.isWxMini
  },
  methods:{
    //获取类别
    getCategoryMajorsApi(index,urlName,idx){
      let params = {
        index:index,
        urlName:urlName
      }
      getCategoryMajors(params).then(res => {
        if(res && res.length>0){
          this.majorType = res
        }
      })
    },
    //获取当前类别下记录
    getRecordsApi(index,idx){
      this.recordsData = []
      this.noData = false
      this.loading = true
      this.majorType.forEach(val =>{
        if(val.categoryID===index){
          val.isChoose = 1
        }else{
          val.isChoose = 0
        }
      })
      let params = {
        userID:getCookie('cdeluid') || this.$route.query.userID,
        index:index,
        source:'M'
      }
      getRecords(params).then(res => {
        if(res && res.length>0){
          this.recordsData = res
        }else{
          this.noData = true
        }
        this.loading = false
      })

      this.kmSwiper.slideTo(idx, 1000, false);
    },
    backToExam(){
      this.$router.push({
        path:'/entry'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-con{
  .header{
    margin-bottom:0;
  }
}
.re-main{
  .subTit {
    padding: 0.267rem 0 0.4rem;
    position: relative;
    z-index: 9;
  }
  .swiper-slide {
    position: relative;
    z-index: 1;
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.427rem;
    color: #666;
    width: auto !important;
    margin-left: 0.4rem;
    &.on {
      color: #3EC93E;
      i{
        display: block;
      }
    }
    i {
      display: none;
      position: absolute;
      left: 50%;
      bottom: 0;
      margin-left: -0.16rem;
      width: 0.32rem;
      height: 0.08rem;
      border-radius: 0.04rem;
      background: #3EC93E;
    }
  }

  .conBox {
    padding: 0 0.4rem;
    .listBox {
      margin-bottom: 0.533rem;
      .roomBox {
        background: #fff;
        border-radius: 0.107rem;
        margin-bottom: 0.4rem;
        -webkit-box-shadow: 0 0 0.16rem rgba(236,233,233,0.5);
        -moz-box-shadow: 0 0 0.16rem rgba(236,233,233,0.5);
        box-shadow: 0 0 0.16rem rgba(236,233,233,0.5);
      }
      .roomBox-tit {
        position: relative;
        z-index: 1;
        height: 1.467rem;
        cursor: pointer;
        .rtTxt {
          float: left;
          width: 7.6rem;
          height: 1.467rem;
          line-height: 1.467rem;
          font-size: 0.453rem;
          font-weight: 700;
          margin-left: 0.933rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .rtJian-l {
          position: absolute;
          top: 50%;
          left: 0.267rem;
          margin-top: -0.2rem;
          width: 0.4rem;
          height: 0.4rem;
          background: url(//m.med66.com/qz/resources/images/qz/moniExam/icon_09.png) no-repeat;
          background-size: 100% 100%;
          transition: all 0.2s linear;
          -webkit-transition: all 0.2s linear;
        }
        .rtJian-r {
          position: absolute;
          top: 50%;
          right: 0.347rem;
          margin-top: -0.12rem;
          width: 0.147rem;
          height: 0.227rem;
          background: url(//m.med66.com/qz/resources/images/qz/moniExam/icon_09.png) no-repeat;
          background-size: 100% 100%;
        }
        &.on {
          .rtJian-l {
            transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
          }
        }
      }
      .roomBox-con {
        padding: 0 0.533rem;
        .unit {
          margin-bottom: 0.133rem;
        }
        .uTit {
          padding: 0 0.267rem;
          height: 1.067rem;
          line-height: 1.067rem;
          font-size: 0.373rem;
          clear: both;
          background: #f9f9f9;
          border-radius: 0.08rem;
          margin-bottom: 0.133rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .uList {
          height: 1.067rem;
          clear: both;
        }
        .uList-num {
          width: 1.333rem;
          line-height: 1.067rem;
          font-size: 0.32rem;
          text-align: right;
          b {
            font-size: 0.48rem;
          }
        }
        .uList-time {
          line-height: 1.067rem;
          font-size: 0.32rem;
          color: #999;
          margin-left: 0.72rem;
        }
        .uList-btn {
          display: block;
          width: 1.307rem;
          height: 0.507rem;
          line-height: 0.54rem;
          text-indent: 0.293rem;
          font-size: 0.32rem;
          color: #3ec93e;
          margin: 0.267rem 0 0 0;
          border-radius: 0.267rem;
          border: 1px solid #3ec93e;
          background: url(//m.med66.com/qz/resources/images/qz/moniExam/icon_10.png) no-repeat 1.067rem center;
          background-size: 0.107rem 0.16rem;
        }
      }
    }
    .nullBox {
      display: block;
      padding: 3.2rem 0 0;
    }
    .nullBox-pic {
      display: block;
      width: 6.24rem;
      height: 4.453rem;
      margin: 0 auto 0.48rem;
    }
    .nullBox-txt {
      text-align: center;
      line-height: 0.587rem;
      font-size: 0.427rem;
      color: #666;
      margin-bottom: 0.4rem;
    }
    .nullBox-btn {
      display: block;
      width: 3.68rem;
      height: 1.067rem;
      line-height: 1.067rem;
      text-align: center;
      font-size: 0.427rem;
      color: #fff;
      background: #3ec93e;
      border-radius: 0.533rem;
      margin: 0 auto;
    }
  }
}
</style>
